import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'
/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import styleA from './style'
import styleB from '../../style'

import Container from '../partials/Container'
import CommunityTable from '../../partials/CommunityTable'

import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editor: {
        search: {
          input: '',
          active: false
        }
      }
    }
  }

  componentWillMount() {
    const _searchMyCommunities = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _searchMyCommunities()
        }

        access.modCom(this.props.User.me.permissions || {})
          ? this.props.Community.getAllCommunities()
          : this.props.Community.getMyCommunities()
      }, 500)
    }

    _searchMyCommunities()
  }

  onItemClick(e) {
    e.preventDefault()
    const comId = e.currentTarget.dataset.comid

    if (!comId) {
      return
    }

    return this.props.history.push(`${this.props.location.pathname}/${comId}`)
  }

  onSearchInputChange(e) {
    console.log(e.target.value)
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          input: e.target.value
        }
      }
    })
  }

  onSearchClick() {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          active: true
        }
      }
    })
  }

  onAddClick(e) {
    e.preventDefault()
    return this.props.history.push(
      `${this.props.location.pathname}/new`.replace('//', '/')
    )
  }

  onSearchSubmit(e) {
    e.preventDefault()

    this.props.Community.searchCommunity(this.state.editor.search.input)
  }

  render() {
    return (
      <Container {...this.props}>
        <Row>
          <Col xs="12" lg="6">
            <h2 className={css(styleB.headers.h2)}>Community list</h2>
          </Col>
          <Col
            style={{
              overflow: `hidden`,
              position: `relative`,
              transition: `0.2s`
            }}
          >
            {access.adminCom(this.props.User.me.permissions || {}) ? (
              <SearchArea
                theme={THEME_LIST[this.props.Config.theme]}
                style={{
                  transition: `0.2s`,
                  width: `100%`,
                  position: `absolute`,
                  ...(this.state.editor.search.active
                    ? {
                        top: 0,
                        left: `15px`
                      }
                    : {
                        top: `-100px`,
                        left: `15px`
                      })
                }}
                onInputChange={this.onSearchInputChange.bind(this)}
                onSubmit={this.onSearchSubmit.bind(this)}
                editor={this.state.editor}
              />
            ) : null}
            <NavigationArea
              style={{
                transition: `0.2s`,
                width: `100%`,
                position: `absolute`,

                ...(!this.state.editor.search.active
                  ? {
                      top: 0,
                      left: `15px`
                    }
                  : {
                      top: `100px`,
                      left: `15px`
                    })
              }}
              showSearch={access.adminCom(this.props.User.me.permissions || {})}
              editor={this.state.editor}
              onSearchClick={this.onSearchClick.bind(this)}
              onAddClick={this.onAddClick.bind(this)}
            />
          </Col>
        </Row>
        <Row>
          <CommunityTable
            theme={THEME_LIST[this.props.Config.theme]}
            communities={
              this.state.editor.search.active
                ? this.props.Community.search.slice()
                : access.modCom(this.props.User.me.permissions || {})
                  ? this.props.Community.all.slice()
                  : this.props.Community.my.slice()
            }
            // activeId={this.state.active.id}
            onClick={this.onItemClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

const SearchArea = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      style={props.style || {}}
      className={`row ${css(
        styleA.search.container,
        styleA[props.theme.name]
          ? styleA[props.theme.name].search.container
          : null
      )}`}
    >
      <Col className={css(styleA.search.inputWrapper)}>
        <input
          type={`text`}
          placeholder={`search...`}
          value={props.editor.search.input}
          onChange={props.onInputChange}
          className={css(styleA.search.input)}
        />
      </Col>
      <Col xs="4" className={css(styleA.search.inputWrapper)}>
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.search.button
          )}
        >
          Search
        </button>
      </Col>
    </form>
  )
}

const NavigationArea = props => {
  return (
    <Row style={props.style || {}}>
      <Col>
        {!props.showSearch ? null : (
          <span
            className={css(
              styleB.buttons.button,
              styleB.buttons.red,
              props.editor.enabled ? styleB.buttons.redActive : null
            )}
            onClick={props.onSearchClick}
          >
            Search
          </span>
        )}
      </Col>
      <Col>
        <span
          className={css(styleB.buttons.button, styleB.buttons.red)}
          onClick={props.onAddClick}
        >
          Add new
        </span>
      </Col>
    </Row>
  )
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Community/Main/Main/index.js